export const RE_CAPTCHA_V3_SITE_KEY = '6LfWo2obAAAAAGrDTLwC5vmKOkumRM1OYXZEMBQq';
// export const RE_CAPTCHA_V2_SITE_KEY = '6LcFvAccAAAAAJNq6VBigJgusWeifp4cJ9-4t8dq'; // checkbox
export const RE_CAPTCHA_V2_SITE_KEY = '6Lcw4wscAAAAAHwbESe78xTTKjnQfqe-b6LEkVBk'; // invisible
